import { type IntlShape } from 'react-intl'

import {
  type UserOrderResponseWithFlagsSubOrdersInner,
  type UserSubOrderV2,
} from '@redteclab/api/clients/bully'

import { parcelLabAccessorGetParcelLabBodyItem } from './parcelLabAccessorGetParcelLabBodyItem'
import { type ParcelLabResponse } from './ParcelLabTypes'

export const parcelLabAccessorGetParcelLabDates = (
  intl: IntlShape,
  subOrder: UserSubOrderV2 | UserOrderResponseWithFlagsSubOrdersInner,
  parcelLabData?: ParcelLabResponse,
): { deliveryDate: string; estimatedDate: string | undefined } => {
  if (!parcelLabData?.header) {
    return { deliveryDate: '', estimatedDate: undefined }
  }

  const latestParcelLabUpdate = parcelLabData.header[0].last_delivery_status
  const latestParcelLabDeliveryStatus =
    parcelLabData.header[0].last_delivery_status.status

  const latestParcelLabDeliveryStatusIsDelivered =
    latestParcelLabDeliveryStatus === 'Delivered'

  const isOrderDelivered = subOrder.status === 'delivered'

  const estimatedDate =
    parcelLabAccessorGetParcelLabBodyItem(parcelLabData)?.ParsedSpecifics
      ?.startDay

  const deliveredDate = latestParcelLabDeliveryStatusIsDelivered
    ? latestParcelLabUpdate.timestamp
    : parcelLabAccessorGetParcelLabBodyItem(parcelLabData, isOrderDelivered)
        ?.timestamp

  const deliveryDate = intl.formatDate(
    isOrderDelivered || latestParcelLabDeliveryStatusIsDelivered
      ? deliveredDate
      : estimatedDate,
    {
      day: '2-digit',
      month: '2-digit',
      year: '2-digit',
    },
  )

  return { deliveryDate, estimatedDate }
}
